<template>
    <div class="upload-container">
        <div class="flex-wrap">
            <el-upload
                v-if="ifUpload && cdnUrl.length < max"
                :action="action"
                :name="name"
                :on-progress="onProgress"
                drag
                :before-upload="beforeUpload"
                :show-file-list="false"
                :limit="limit"
                class="images-upload">
                <template v-if="!disabled">
                    <el-button v-if="isBtn" slot="trigger" size="small" icon="el-icon-upload" type="primary">选取文件</el-button>
                    <div v-else slot="trigger" class="image-slot" :style="`width: ${otherWidth ? otherWidth : width + 'px'};height:${otherHeight ? otherHeight : height + 'px'}`">
                        <i class="el-icon-plus" />
                    </div>
                    <div v-if="msg" style="display: inline-block; font-size: 12px; margin-left: 10px; color: #666666">
                        {{ msg }}
                    </div>
                </template>
            </el-upload>
            <template v-for="(item, index) in cdnUrl">
                <div v-if="!isBtn && isImg(item) == 'img'" :key="index" class="images">
                    <el-image :src="getLink(item)" :style="`width: ${otherWidth ? otherWidth : width + 'px'};height:${otherHeight ? otherHeight : height + 'px'}`" fit="cover" />

                    <div class="mask" @click.stop="">
                        <div class="actions">
                            <span title="预览" @click.stop="preview(index)">
                                <i class="el-icon-zoom-in" />
                            </span>
                            <span v-if="!disabled" title="移除" @click.stop="remove(index)">
                                <i class="el-icon-delete" />
                            </span>
                            <span v-if="!disabled" v-show="cdnUrl.length > 1" title="左移" :class="{ disabled: index == 0 }" @click.stop="move(index, 'left')">
                                <i class="el-icon-back" />
                            </span>
                            <span v-if="!disabled" v-show="cdnUrl.length > 1" title="右移" :class="{ disabled: index == cdnUrl.length - 1 }" @click.stop="move(index, 'right')">
                                <i class="el-icon-right" />
                            </span>
                        </div>
                    </div>
                </div>
            </template>
            <template v-for="(item, index) in cdnUrl">
                <div v-if="isBtn || isImg(item) != 'img'" :key="item" class="files">
                    <div
                        v-if="isVideo(item)"
                        @click.stop="openVideo(item)"
                        class="video-wrap"
                        :style="`width: ${otherWidth ? otherWidth : width + 'px'};height:${otherHeight ? otherHeight : height + 'px'}`">
                        <img class="video-img" :src="videoCoverImgs[item] || require('./imgs/video.jpg')" />
                        <!-- <i class="el-icon-video-play" :size="width" :style="{ 'font-size': `${width * 0.3}px` }"></i> -->

                        <div class="mask" @click.stop="">
                            <div class="actions">
                                <span title="预览" @click.stop="preview(index)">
                                    <i class="el-icon-zoom-in" />
                                </span>
                                <span v-if="!disabled" title="移除" @click.stop="remove(index)">
                                    <i class="el-icon-delete" />
                                </span>
                                <span v-if="!disabled" v-show="cdnUrl.length > 1" title="左移" :class="{ disabled: index == 0 }" @click.stop="move(index, 'left')">
                                    <i class="el-icon-back" />
                                </span>
                                <span v-if="!disabled" v-show="cdnUrl.length > 1" title="右移" :class="{ disabled: index == cdnUrl.length - 1 }" @click.stop="move(index, 'right')">
                                    <i class="el-icon-right" />
                                </span>
                            </div>
                        </div>
                    </div>
                    <template v-else>
                        <i class="el-icon-tickets" style="color: #dadada; margin-right: 6px"></i>
                        <span
                            @click.stop="openFiles(item)"
                            :title="item"
                            style="display: block; overflow: hidden; width: 70%; white-space: nowrap; text-overflow: ellipsis; color: #666666">
                            附件{{ index + 1 }} {{ item.replace(/.*\./g, ".") }}
                        </span>
                        <i v-if="!disabled" @click.stop="remove(index)" class="el-icon-error top-right-close" style="color: #d6d6d6" />
                    </template>
                </div>
            </template>
        </div>
        <div v-if="!notip" class="el-upload__tip">
            <div style="display: inline-block">
                <el-alert
                    :title="`上传图片支持 ${ext.join(' / ')} 格式，单张图片大小不超过 ${size}MB，建议图片尺寸为 ${width}*${height}，且图片数量不超过 ${max} 张`"
                    type="info"
                    show-icon
                    :closable="false" />
            </div>
        </div>
        <el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body>
            <!-- <cutPage v-if="dialogVisible" ref="cutPage" :img="link"></cutPage> -->
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
            </div>
        </el-dialog>
        <el-image-viewer
            v-if="imageViewerVisible"
            :on-close="
                () => {
                    imageViewerVisible = false;
                }
            "
            :url-list="[dialogImageUrl]" />
        <el-dialog title="文件预览" :visible.sync="openPdf" :append-to-body="true" :close-on-click-modal="false">
            <!-- <pdf ref="pdf" v-for="i in numPages" :key="i" :src="pdfUrl" :page="i"></pdf> -->
        </el-dialog>
        <el-dialog title="视频播放" :visible.sync="videoData.visible" :append-to-body="true" :close-on-click-modal="false">
            <div class="flex" style="align-items: center; justify-content: center; height: 500px">
                <video v-if="videoData.visible" :src="getLink(videoData.link)" style="width: 500px; height: 500px" autoplay controls></video>
            </div>

            <!-- <pdf ref="pdf" v-for="i in numPages" :key="i" :src="pdfUrl" :page="i"></pdf> -->
        </el-dialog>
    </div>
</template>
<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import upfileReq from "./upFiles";
import { queryHelpFileUrlMd5 } from "@/api/cdn";
// import pdf from 'vue-pdf'

export default {
    name: "FileUpload",
    components: {
        ElImageViewer,
        // cutPage: () => import("./cropper.vue"),
        // pdf
    },
    props: {
        limit: {
            type: Number,
            default: 5,
        },
        ifUpload: {
            type: Boolean,
            default: true,
        },
        value: {
            type: Array,
            default: () => [],
        },
        cut: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        action: {
            type: String,
            default: "/api/common/fileServer/upload",
            // required: true
        },
        msg: {
            type: String,
            default: "",
        },
        data: {
            type: Object,
            default: () => {},
        },
        name: {
            type: String,
            default: "file",
        },
        url: {
            type: Array,
            default: () => [],
        },
        max: {
            type: Number,
            default: 3,
        },
        size: {
            type: Number,
            default: 2,
        },
        otherWidth: {
            type: String,
            default: "",
        },
        otherHeight: {
            type: String,
            default: "",
        },
        width: {
            type: Number,
            default: 105,
        },
        height: {
            type: Number,
            default: 105,
        },
        placeholder: {
            type: String,
            default: "",
        },
        notip: {
            type: Boolean,
            default: true,
        },
        ext: {
            type: Array,
            default: () => ["jpg", "png", "gif", "bmp", "jpeg", "pdf"], //
        },
        isBtn: {
            type: Boolean,
            default: false,
        },
    },
    model: {
        event: "change",
    },
    mounted() {
        if (this.url && this.url.length) this.localUrl = this.formatUrl(this.url);
        this.getCdnUrl();
    },
    watch: {
        value: {
            handler(newValue, oldValue) {
                if ((!oldValue || !(Array.isArray(oldValue) && oldValue.length)) && newValue) {
                    this.localUrl = this.formatUrl(newValue);
                    this.getCdnUrl();
                }
            },
            immediate: true,
        },
    },
    data() {
        return {
            cdnUrl: [],
            videoCoverImgs: {},
            videoCoverImgsLoad: {},
            localUrl: [],
            loading: false,
            dialogVisible: false,
            localValue: [],
            dialogImageUrl: "",
            imageViewerVisible: false,
            progress: {
                preview: "",
                percent: 0,
            },
            link: "",
            openPdf: false,
            videoData: {
                link: "",
                visible: false,
            },
            numPages: null,
            pdfUrl: "",
        };
    },
    methods: {
        formatUrl(list) {
            let myList = list.filter((item) => item).map((item) => {
                let arr = item.split("/");
                let url = arr[arr.length - 1];
                return url;
            });
            return myList;
        },
        getCdnUrl() {
            return new Promise((resolve) => {
                if (Array.isArray(this.localUrl) && this.localUrl.length) {
                    queryHelpFileUrlMd5({ codes: this.formatUrl(this.localUrl) }).then((res) => {
                        this.cdnUrl = res.map((item) => item.url);
                        this.getVideoCoverImgs();
                        resolve();
                    });
                } else {
                    this.cdnUrl = [];
                    resolve();
                }
            });
        },
        getVideoCoverImgs() {
            this.cdnUrl.forEach(async (url) => {
                if (url && this.isVideo(url) && !this.videoCoverImgs[url] && !this.videoCoverImgsLoad[url]) {
                    this.videoCoverImgsLoad[url] = true;
                    const urlImg = await this.generateVideoCover(url);
                    this.$set(this.videoCoverImgs, url, urlImg);
                    //   this.videoCoverImgs[url] = await this.generateVideoCover(url);
                    this.videoCoverImgsLoad[url] = false;
                }
            });
        },
        async generateVideoCover(url) {
            const video = document.createElement("video");
            video.preload = "metadata";
            video.crossOrigin = "anonymous";
            video.src = this.getLink(url);
            video.onloadedmetadata = () => {
                video.currentTime = 1; // 跳到第一帧
            };
            return new Promise((resolve) => {
                video.onseeked = () => {
                    const canvas = document.createElement("canvas");
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    try {
                        resolve(canvas.toDataURL("image/png"));
                    } catch (e) {
                        resolve();
                    }
                };
            });
        },
        getLink(src) {
            if (src.indexOf("//") == -1) {
                return "//res.jzyglxt.com/idi/" + src;
            }
            return src;
        },
        isImg(str) {
            return str.toLowerCase().search(/gif|jpg|jpeg|bmp|png/) > -1 ? "img" : "files";
        },
        isVideo(str) {
            return str.toLowerCase().search(/(mp4|mov)/) > -1 ? true : false;
        },
        openFiles(item) {
            //   console.log(this.isImg(item))
            if (item.toLowerCase().indexOf(".pdf") > -1) {
                this.pdfUrl = item;
                let loadingTask = pdf.createLoadingTask(item);
                loadingTask.promise
                    .then(
                        (pdf) => {
                            this.numPages = pdf.numPages;
                        },
                        (err) => {
                            console.error("pdf 加载失败", err);
                        },
                    )
                    .catch((err) => {
                        console.error("pdf 加载失败", err);
                    });

                this.openPdf = true;
                // this.getNumPages();
            } else if (this.isImg(item) == "img") {
                this.dialogImageUrl = item;
                this.imageViewerVisible = true;
            } else {
            }
        },
        // 预览
        openVideo(src) {
            this.videoData.link = src;
            this.videoData.visible = true;
        },
        preview(index) {
            this.dialogImageUrl = this.getLink(this.value[index]);
            this.imageViewerVisible = true;
        },
        // 移除
        remove(index) {
            let ary = [...this.value];
            ary.splice(index, 1);
            // this.$emit("change", ary);
            // this.$emit("on-change", ary);
            this.localUrl = this.formatUrl(ary);
            this.getCdnUrl().then(() => {
                this.$emit("change", this.localUrl);
                this.$emit("on-change", this.localUrl);
                // this.$emit("update:url", this.localUrl);
            });
        },
        // 移动
        move(index, type) {
            let url = [...this.value];
            if (type == "left" && index != 0) {
                url[index] = url.splice(index - 1, 1, url[index])[0];
            }
            if (type == "right" && index != url.length - 1) {
                url[index] = url.splice(index + 1, 1, url[index])[0];
            }

            // this.$emit("change", url);
            // this.$emit("on-change", url);

            this.localUrl = this.formatUrl(url);
            this.getCdnUrl().then(() => {
                this.$emit("change", this.localUrl);
                this.$emit("on-change", this.localUrl);
                // this.$emit("update:url", this.localUrl);
            });
        },
        beforeUpload(file) {
            if (this.limit <= this.localUrl.length) {
                this.$message.error(`上传数量超过限制`);
                return;
            }
            const fileName = file.name.split(".");
            const fileExt = fileName[fileName.length - 1].toLowerCase();
            const isTypeOk = this.ext?.map((item) => item.toLowerCase()).indexOf(fileExt) >= 0;
            const isSizeOk = file.size / 1024 / 1024 < this.size;
            if (!isTypeOk) {
                this.$message.error(`上传图片只支持 ${this.ext.join(" / ")} 格式！`);
                return false;
            }
            if (!isSizeOk) {
                this.$message.error(`上传图片大小不能超过 ${this.size}MB！`);
                return false;
            }

            this.progress.preview = URL.createObjectURL(file);

            if (this.cut) {
                //如果需要裁减
                // this.handleAvatarSuccess(file)
                console.log(file);
                this.link = file;
                this.dialogVisible = true;
            } else {
                this.loading = true;
                this.upfiles(file);
            }
            return false;
            //   return
        },
        finish() {
            var doc = this.$refs.cutPage.$getCropBlob();

            doc.getCropBlob((data) => {
                this.loading = true;
                this.upfiles(data);
            });
        },
        onProgress(file) {
            this.progress.percent = ~~file.percent;
            if (this.progress.percent == 100) {
                this.progress.preview = "";
                this.progress.percent = 0;
            }
        },
        upfiles(file) {
            var task;

            var formData = new FormData();
            // if (this.isImg) { //图片

            // } else { //文件
            //     formData.append("file", file);
            //     task = upfileReq(this.action, formData)
            // }
            formData.append("file", file);
            task = upfileReq(this.action, formData);
            const loading = this.$loading({
                lock: true,
                text: "文件上传中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });

            task.then(
                (res) => {
                    loading.close();
                    this.loading = false;
                    this.dialogVisible = false;

                    var ary = [...this.value];
                    ary.push(res.url.replace("http:", ""));
                    // this.$emit("change", ary);
                    // this.$emit("on-change", ary);

                    this.localUrl = this.formatUrl(ary);
                    this.getCdnUrl().then(() => {
                        this.$emit("change", this.localUrl);
                        this.$emit("on-change", this.localUrl);
                        // this.$emit("update:url", this.localUrl);
                    });
                },
                (err) => {
                    loading.close();
                    this.$message.warning(err.msg || "上传失败");
                },
            );
        },
        // onSuccess(res) {
        //   if (res.Code == 0) {
        //     // this.value
        //     if (this.cut) {
        //       this.dialogVisible = true;
        //     } else {
        //       var ary = [...this.value];
        //       ary.push(res.Datas);
        //       this.$emit("change", ary);
        //       this.$emit("on-change", ary);
        //     }
        //   } else {
        //     this.$message.warning(res.Msg || "上传失败");
        //   }
        // }
    },
};
</script>
<style lang="scss" scoped>
.upload-container {
    line-height: initial;
    line-height: 40px;
}

.images {
    position: relative;
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 10px;
    //   border: 1px dashed #d9d9d9;
    border-radius: 6px;
    overflow: hidden;

    .el-image {
        display: block;
    }

    &:hover .mask {
        opacity: 1;
    }
    .mask {
        z-index: 10;
        opacity: 0;
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        font-size: 24px;
        background-color: rgba(0, 0, 0, 0.5);
        transition: all 0.3s;

        .actions {
            width: 100px;
            height: 100px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            @include position-center(xy);

            span {
                width: 50%;
                text-align: center;
                color: #fff;
                cursor: pointer;
                transition: all 0.1s;

                &.disabled {
                    color: #999;
                    cursor: not-allowed;
                }

                &:hover:not(.disabled) {
                    transform: scale(1.5);
                }
            }
        }
    }
}

.images-upload {
    display: inline-block;

    ::v-deep .image-slot {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        color: #909399;
        font-size: 30px;
        background-color: transparent;

        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
}

::v-deep .el-upload {
    .el-upload-dragger {
        width: auto;
        height: auto;

        &.is-dragover {
            border-width: 1px;
        }

        .progress {
            position: absolute;
            top: 0;

            &::after {
                content: "";
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                background-color: rgba(0, 0, 0, 0.2);
            }

            .el-progress {
                z-index: 1;
                @include position-center(xy);

                .el-progress__text {
                    color: #fff;
                }
            }
        }
    }
}
.video-wrap {
    //   background: lightgray;
    border-radius: 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    .video-img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
    }
}
.files {
    cursor: pointer;
    display: flex;
    align-items: center;
    text-align: left;
    position: relative;
    height: 100%;
    width: 100%;
}
</style>
